export default __webpack_public_path__ + "static/media/marketing.6cc291b2.svg";